/* assets/variant-vspecs-refresh.js */

(function () {
  'use strict';

  const WRAPPER_SELECTOR = '[id^="ProductSpecs-"][data-section-id]';

  function getFormFromElement(el) {
    // Your <select> uses form="product-form-..."
    const formId = el.getAttribute && el.getAttribute('form');
    if (formId) {
      const byId = document.getElementById(formId);
      if (byId && byId.tagName === 'FORM') return byId;
    }

    // Fallbacks
    const section = el.closest('section') || document;
    return (
      section.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function getVariantIdFromForm(form) {
    if (!form) return null;
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return null;
    const id = (idInput.value || '').trim();
    return id || null;
  }

  async function fetchSectionHTML(sectionId, variantId) {
    const url = new URL(window.location.href);
    if (variantId) url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);

    const res = await fetch(url.toString(), {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    });

    if (!res.ok) throw new Error(`Failed section fetch ${sectionId}: ${res.status}`);
    return await res.text();
  }

  function extractWrapper(htmlText, sectionId) {
    const doc = new DOMParser().parseFromString(htmlText, 'text/html');
    return doc.getElementById(`ProductSpecs-${sectionId}`);
  }

  async function updateAll(variantId) {
    const wrappers = Array.from(document.querySelectorAll(WRAPPER_SELECTOR));
    if (!wrappers.length) return;

    await Promise.all(
      wrappers.map(async (dest) => {
        const sectionId = dest.getAttribute('data-section-id');
        if (!sectionId) return;

        try {
          const htmlText = await fetchSectionHTML(sectionId, variantId);
          const src = extractWrapper(htmlText, sectionId);
          if (!src) return;

          dest.innerHTML = src.innerHTML;
        } catch (e) {
          // console.warn('[variant-vspecs-refresh] update failed', e);
        }
      })
    );
  }

  function scheduleUpdateFromOptionSelect(selectEl) {
    const form = getFormFromElement(selectEl);

    // Refresh updates the hidden variant id after option change.
    // Waiting a little avoids reading the old id.
    window.setTimeout(() => {
      const variantId = getVariantIdFromForm(form);
      if (variantId) updateAll(variantId);
    }, 80);
  }

  function wireOptionSelects() {
    document.addEventListener(
      'change',
      (e) => {
        const t = e.target;
        if (!(t instanceof HTMLSelectElement)) return;

        // Matches: name="options[Sample Box]" (and any other option selects)
        if (!t.name || !t.name.startsWith('options[')) return;

        scheduleUpdateFromOptionSelect(t);
      },
      true
    );
  }

  function wireVariantIdInput() {
    // Backup: some theme flows trigger change on input[name=id]
    document.addEventListener(
      'change',
      (e) => {
        const t = e.target;
        if (!(t instanceof HTMLInputElement)) return;
        if (t.name !== 'id') return;

        const variantId = (t.value || '').trim();
        if (variantId) updateAll(variantId);
      },
      true
    );
  }

  function init() {
    wireOptionSelects();
    wireVariantIdInput();

    // Initial sync
    const anyWrapper = document.querySelector(WRAPPER_SELECTOR);
    if (anyWrapper) {
      const section = anyWrapper.closest('section') || document;
      const form =
        section.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');

      const variantId = getVariantIdFromForm(form);
      if (variantId) updateAll(variantId);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();